import { ComponentProps } from 'react'

import { StatusLabel } from '@factorialco/deprecated-design-system'
import { ProcurementValueObjectsPurchaseOrderStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  status: ProcurementValueObjectsPurchaseOrderStatusEnum
}

export const PurchaseOrderStatusLabel = ({ status }: Props) => {
  const statusInfo: Record<
    ProcurementValueObjectsPurchaseOrderStatusEnum,
    { type: ComponentProps<typeof StatusLabel>['type']; label: string }
  > = {
    ['processing']: {
      type: 'neutral',
      label: i18n.t('procurement.purchase_orders.status.processing'),
    },
    ['pending']: {
      type: 'warning',
      label: i18n.t('procurement.purchase_orders.status.pending'),
    },
    ['ordered']: {
      type: 'info',
      label: i18n.t('procurement.purchase_orders.status.ordered'),
    },
    ['partial']: {
      type: 'info',
      label: i18n.t('procurement.purchase_orders.status.partial'),
    },
    ['received']: {
      type: 'info',
      label: i18n.t('procurement.purchase_orders.status.received'),
    },
    ['closed']: {
      type: 'neutral',
      label: i18n.t('procurement.purchase_orders.status.closed'),
    },
    ['draft']: {
      type: 'neutral',
      label: i18n.t('procurement.purchase_orders.status.draft'),
    },
  }
  const { type, label } = statusInfo[status]

  return <StatusLabel type={type}>{label}</StatusLabel>
}
